export const getSessionStorageItem = (key: string): string | null => {
  return sessionStorage.getItem(key);
};

export const setSessionStorageItem = (
  key: string,
  value: string | boolean,
): void => {
  sessionStorage.setItem(key, value.toString());
};

export const removeSessionStorageItem = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const clearSessionStorage = (): void => {
  sessionStorage.clear();
};

export const setLocalStorageItem = (
  key: string,
  value: string | boolean,
): void => {
  value
    ? localStorage.setItem(key, value.toString())
    : localStorage.removeItem(key);
};

export const getLocalStorageItem = (key: string): string | null => {
  return localStorage.getItem(key);
};

export const removeLocalStorageItem = (key: string): void => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = (): void => {
  localStorage.clear();
};
